import { Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { useTenantBranding } from "@/hooks/useTenantBranding";

export function FieldShell() {
  const { profile, currentTenant, signOut } = useAuth();
  
  useTenantBranding();

  const firstName = profile?.full_name?.split(" ")[0] || "Usuário";

  return (
    <div className="flex flex-col min-h-[100dvh] bg-background">
      {/* Minimal header */}
      <header className="sticky top-0 z-50 flex items-center justify-between px-4 py-3 border-b bg-background/95 backdrop-blur-md">
        <div className="flex items-center gap-3 min-w-0">
          {currentTenant?.logo_url ? (
            <img src={currentTenant.logo_url} alt="" className="h-8 w-8 rounded-lg object-contain" />
          ) : (
            <div className="h-8 w-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary font-bold text-sm">
              {currentTenant?.name?.charAt(0) || "S"}
            </div>
          )}
          <div className="min-w-0">
            <p className="text-sm font-semibold truncate">Olá, {firstName}</p>
            <p className="text-[11px] text-muted-foreground truncate">{currentTenant?.name}</p>
          </div>
        </div>
        <Button variant="ghost" size="sm" onClick={signOut} className="gap-2 text-muted-foreground shrink-0">
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">Sair</span>
        </Button>
      </header>

      {/* Full-width content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
